import { render, staticRenderFns } from "./counterpartiesListBottom.vue?vue&type=template&id=3633a476"
import script from "./counterpartiesListBottom.vue?vue&type=script&lang=js"
export * from "./counterpartiesListBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports